export default __webpack_public_path__ + "static/media/adn3.c8096c14.png";